import type { CartItem } from '@src/domains/cart';

export const formatCartItemPackageTariffs = (items: CartItem[]) =>
  items.reduce((acc, curr) => {
    for (const { tariff, quantity } of curr.tariffs) {
      const tariffName = tariff.type.name;

      acc[tariffName] = (acc[tariffName] || 0) + quantity;
    }

    return acc;
  }, {} as Record<string, number>);
